import { BulkToast } from '@/components/words/bulk-add/bulk-toast';
import { WordRail } from '@/components/words/word-rail';
import { WordsMosaic } from '@/components/words/words-mosaic';
import { WordsSidebar } from '@/components/words/words-sidebar';
import { BulkAddProvider } from '@/lib/bulk-add/bulk-session';
import { useIsDesktopViewport, useResultViewMode } from '@/lib/result-view-mode';
import { WordsNavProvider } from '@/lib/words-nav';
import { Outlet, createFileRoute, useRouterState } from '@tanstack/react-router';

export const Route = createFileRoute('/words')({
  component: WordsLayout,
});

function WordsLayout() {
  // On mobile only one zone is shown at a time: the search list on the index
  // route, the main content on every sub-route. Desktop shows all zones at once,
  // so the modifier is a no-op there (see the .words-app grid in styles.css).
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isListView = pathname === '/words' || pathname === '/words/';

  // Mosaic is a desktop-only alternative view for the main content pane —
  // toggling it replaces whatever's currently there (the empty state, a word
  // detail, bulk-add, settings) with the card grid. Picking a card turns
  // mosaic back off (see words-mosaic.tsx) so the opened word's detail shows.
  const [viewMode] = useResultViewMode();
  const isDesktop = useIsDesktopViewport();
  const showMosaic = viewMode === 'mosaic' && isDesktop;

  // BulkAddProvider wraps the whole shell so a bulk-add review session survives
  // navigation between destinations — its analysis keeps polling and its
  // completion toast + rail badge work even when the bulk-add page is off-screen.
  return (
    <WordsNavProvider>
      <BulkAddProvider>
        <div className={`words-app${isListView ? ' words-app--list' : ' words-app--detail'}`}>
          <WordRail />
          <WordsSidebar />
          <div className="words-content">{showMosaic ? <WordsMosaic /> : <Outlet />}</div>
        </div>
        <BulkToast />
      </BulkAddProvider>
    </WordsNavProvider>
  );
}
